let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lcY00")).then(() => parcelRequire('93XNc'));